"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const InputCards_1 = __importDefault(require("./InputCards"));
const icons_1 = require("./common/icons");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const FormSettingsContext_1 = require("../context/FormSettingsContext");
const apiFetch_1 = require("../utils/apiFetch");
const config_1 = require("../config");
const FormSelection = ({ formId, onBack }) => {
    var _a, _b;
    const { currentSchema, selectedForm, setSelectedForm, handleRemoveForm } = (0, FormSettingsContext_1.useFormSetting)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [showWarning, setShowWarning] = (0, react_1.useState)(false);
    // Fetch form data when formId changes
    (0, react_1.useEffect)(() => {
        if (!formId) {
            setSelectedForm(null);
            return;
        }
        const fetchFormById = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            setLoading(true);
            setError(null);
            try {
                // Get auth token
                const token = localStorage.getItem('authToken');
                const headers = {};
                if (token) {
                    headers.Authorization = `Bearer ${(0, config_1.getAuthToken)()}`;
                }
                const json = yield (0, apiFetch_1.apiFetch)(`${process.env.REACT_APP_API_BASE_URL}/v1/question/${formId}`, {
                    headers
                });
                const formData = (json === null || json === void 0 ? void 0 : json.data) || json;
                setSelectedForm({
                    _id: formData._doc._id,
                    _doc: formData._doc,
                    title: formData.title || ((_a = formData._doc) === null || _a === void 0 ? void 0 : _a.title),
                    bannerUrl: formData.bannerUrl || ((_b = formData._doc) === null || _b === void 0 ? void 0 : _b.bannerUrl) || "/placeholder-banner.png",
                    questions: formData.questions || [],
                });
            }
            catch (err) {
                console.error("Error fetching form:", err);
                setError(err.message || "Failed to fetch form data");
            }
            finally {
                setLoading(false);
            }
        });
        fetchFormById();
    }, [formId, setSelectedForm]);
    const handleRemoveFormClick = () => {
        setShowWarning(true);
    };
    const handleConfirmRemove = () => {
        setShowWarning(false);
        handleRemoveForm();
        onBack();
    };
    const handleCancelRemove = () => {
        setShowWarning(false);
    };
    if (loading) {
        return ((0, jsx_runtime_1.jsx)(material_1.Box, { width: { xs: "100%", sm: 240 }, height: "100%", borderRight: "1px solid #eee", p: 2, bgcolor: "#fafafa", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", children: (0, jsx_runtime_1.jsx)(material_1.Box, { children: "Loading form..." }) }));
    }
    if (error) {
        return ((0, jsx_runtime_1.jsxs)(material_1.Box, { width: { xs: "100%", sm: 240 }, height: "100%", borderRight: "1px solid #eee", p: 2, bgcolor: "#fafafa", display: "flex", flexDirection: "column", children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { mb: 2, fontWeight: 600, fontSize: "1rem", sx: {
                        cursor: "pointer",
                        "&:hover": { textDecoration: "underline" },
                    }, onClick: onBack, children: [(0, jsx_runtime_1.jsx)(icons_1.BackIcon, {}), " Back"] }), (0, jsx_runtime_1.jsx)(material_1.Box, { color: "error.main", textAlign: "center", children: error })] }));
    }
    if (!selectedForm) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { width: { xs: "100%", sm: 240 }, height: "100%", borderRight: "1px solid #eee", p: 2, bgcolor: "#fafafa", display: "flex", flexDirection: "column", overflow: "auto", children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { mb: 2, display: "flex", justifyContent: "space-between", alignItems: "center", children: [(0, jsx_runtime_1.jsx)(material_1.Box, { fontWeight: 600, fontSize: "1rem", sx: { flex: 1 }, children: (_b = (((_a = selectedForm._doc) === null || _a === void 0 ? void 0 : _a.title) || selectedForm.title)) === null || _b === void 0 ? void 0 : _b.replace(/<\/?p>/g, "") }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                                    cursor: "pointer",
                                    padding: "4px",
                                    borderRadius: "4px",
                                    "&:hover": { backgroundColor: "#e0e0e0" },
                                }, onClick: handleRemoveFormClick, children: (0, jsx_runtime_1.jsx)(Close_1.default, { width: 16, height: 16 }) })] }), selectedForm.questions.map((q) => {
                        var _a;
                        // Check if this question is already in the schema
                        const isAlreadyInSchema = ((_a = currentSchema === null || currentSchema === void 0 ? void 0 : currentSchema.inputs) === null || _a === void 0 ? void 0 : _a.some((input) => input.formInputId === q._id)) || false;
                        return ((0, jsx_runtime_1.jsx)(material_1.Box, { mb: 1, children: (0, jsx_runtime_1.jsx)(InputCards_1.default, { questionObj: q, type: q.type, question: q.question.replace(/<\/?p>/g, ""), disabled: isAlreadyInSchema }) }, q._id));
                    })] }), (0, jsx_runtime_1.jsxs)(material_1.Dialog, { open: showWarning, onClose: handleCancelRemove, children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, { children: "Remove Form Selection" }), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { children: "Are you sure you want to remove the current form selection? This will reset the form configuration." }), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, { onClick: handleCancelRemove, color: "primary", children: "Cancel" }), (0, jsx_runtime_1.jsx)(material_1.Button, { onClick: handleConfirmRemove, color: "error", variant: "contained", children: "Remove" })] })] })] }));
};
exports.default = FormSelection;
